export const toAudioPath = (gs_path: string) => {
  const [_, bucket, path] = /gs:\/\/([-\w]+)\/(.*)/.exec(gs_path) ?? [];
  return `https://storage.googleapis.com/${bucket}/${path}`;
};
